import api from "./api";

const API_URL = "/BlockchainLog";

const unwrap = (res) => res?.data ?? null;

export const getBlockchainLogs = async () =>
    unwrap(await api.get(API_URL));

export const getBlockchainLogById = async (id) =>
    unwrap(await api.get(`${API_URL}/${id}`));

export const searchBlockchainLogs = async (query) => {
    const logs = await getBlockchainLogs();

    if (!Array.isArray(logs)) return [];

    const q = String(query || "").trim().toLowerCase();

    if (!q) return logs;

    return logs.filter((log) =>
        JSON.stringify(log).toLowerCase().includes(q)
    );
};

export default {
    getBlockchainLogs,
    getBlockchainLogById,
    searchBlockchainLogs,
};